import { Box, Flex, Input, Text, Tooltip } from "@chakra-ui/react";
import { IconCardDiscover, IconCardExpress, IconCardMaster, IconCardVisa } from "components/icons/Icons";

const getCardBrandLabel = (brand?: string) => {
  const b = String(brand || "").toLowerCase();
  if (b === "visa") return "Visa";
  if (b === "mastercard") return "Mastercard";
  if (b === "amex") return "American Express";
  if (b === "discover") return "Discover";
  return "Card";
};

export default function NewCardForm(props: {
  cardBrand: string;
  cardHolderName: string;
  setCardHolderName: (next: string) => void;
  onFocusStripe: () => void;
}) {
  const {
    cardBrand,
    cardHolderName,
    setCardHolderName,
    onFocusStripe,
  } = props;

  return (
    <Box
      mt="14px"
      padding={{ md: "18px", base: "16px" }}
      border="1px solid #E6ECF3"
      borderRadius="12px"
      bg="#FFF"
    >
      <Box mb="16px">
        <Text fontSize="14px" fontWeight="500" color="#0B0E10" mb="8px">
          Card number
        </Text>
        <Box position="relative">
          <Box
            padding="12px 16px"
            paddingRight={{ base: "16px", md: "140px" }}
            borderRadius="12px"
            border="1px solid #E9E9E9"
            bg="white"
            h="48px"
            display="flex"
            alignItems="center"
          >
            <Box id="payment-card-number-element" w="100%"></Box>
          </Box>
          {/* Desktop: show all icons inline */}
          <Flex
            display={{ base: "none", md: "flex" }}
            position="absolute"
            right="12px"
            top="50%"
            transform="translateY(-50%)"
            gap="4px"
            alignItems="center"
          >
            <Tooltip label={getCardBrandLabel("visa")} placement="top" hasArrow>
              <Box opacity={cardBrand === "visa" || cardBrand === "" ? 1 : 0.3}>
                <IconCardVisa w="28px" h="18px" />
              </Box>
            </Tooltip>
            <Tooltip label={getCardBrandLabel("amex")} placement="top" hasArrow>
              <Box opacity={cardBrand === "amex" || cardBrand === "" ? 1 : 0.3}>
                <IconCardExpress w="28px" h="18px" />
              </Box>
            </Tooltip>
            <Tooltip label={getCardBrandLabel("discover")} placement="top" hasArrow>
              <Box opacity={cardBrand === "discover" || cardBrand === "" ? 1 : 0.3}>
                <IconCardDiscover w="28px" h="18px" />
              </Box>
            </Tooltip>
            <Tooltip label={getCardBrandLabel("mastercard")} placement="top" hasArrow>
              <Box opacity={cardBrand === "mastercard" || cardBrand === "" ? 1 : 0.3}>
                <IconCardMaster w="28px" h="18px" />
              </Box>
            </Tooltip>
          </Flex>
          {/* Mobile: show only detected card icon below input */}
          {cardBrand && cardBrand !== "" && (
            <Flex
              display={{ base: "flex", md: "none" }}
              mt="8px"
              gap="4px"
              alignItems="center"
            >
              <Tooltip label={getCardBrandLabel(cardBrand)} placement="top" hasArrow>
                <Box>
                  {cardBrand === "visa" && <IconCardVisa w="32px" h="20px" />}
                  {cardBrand === "amex" && <IconCardExpress w="32px" h="20px" />}
                  {cardBrand === "discover" && <IconCardDiscover w="32px" h="20px" />}
                  {cardBrand === "mastercard" && <IconCardMaster w="32px" h="20px" />}
                </Box>
              </Tooltip>
            </Flex>
          )}
        </Box>
      </Box>

      <Box mb="16px">
        <Text fontSize="14px" fontWeight="500" color="#0B0E10" mb="8px">
          Name on card
        </Text>
        <Input
          name="name-on-card"
          borderRadius="12px"
          border="1px solid #E9E9E9"
          background="#FFF"
          h="48px"
          placeholder="John Doe"
          _placeholder={{ color: "#9CA3AF", fontSize: "14px" }}
          value={cardHolderName}
          onChange={(e) => {
            onFocusStripe();
            setCardHolderName(e.target.value);
          }}
        />
      </Box>

      <Flex gap="12px" mb="12px">
        <Box flex="1">
          <Text fontSize="14px" fontWeight="500" color="#0B0E10" mb="8px">
            Expiration date
          </Text>
          <Box
            padding="12px 16px"
            borderRadius="12px"
            border="1px solid #E9E9E9"
            bg="white"
            h="48px"
            display="flex"
            alignItems="center"
          >
            <Box id="payment-card-expiry-element" w="100%"></Box>
          </Box>
        </Box>
        <Box flex="1">
          <Text fontSize="14px" fontWeight="500" color="#0B0E10" mb="8px">
            CVV
          </Text>
          <Box
            padding="12px 16px"
            borderRadius="12px"
            border="1px solid #E9E9E9"
            bg="white"
            h="48px"
            display="flex"
            alignItems="center"
          >
            <Box id="payment-card-cvc-element" w="100%"></Box>
          </Box>
        </Box>
      </Flex>
    </Box>
  );
}
